import React, { Component } from "react";
import styled, { css } from "styled-components";

function humanFileSize(bytes, si=false, dp=1) {
    const thresh = si ? 1000 : 1024;
  
    if (Math.abs(bytes) < thresh) {
      return bytes + ' B';
    }
  
    const units = si 
      ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] 
      : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
    let u = -1;
    const r = 10**dp;
  
    do {
      bytes /= thresh;
      ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
  
  
    return bytes.toFixed(dp) + ' ' + units[u];
  }

export default class FileReady extends Component {
    constructor(props) {
        super(props)
    }

    render(){
        const { name, size, type, onClick, uploadProgress } = this.props
        const nameSplit = name.split(".")
        const fileName = nameSplit.slice(0, nameSplit.length-1).join(".")
        const extension = nameSplit[nameSplit.length-1]
        return (
            <Wrapper onClick={onClick}>       
                <Progress uploadProgress={uploadProgress} />         
                <FileName>                    
                    <WithEllipsis>{fileName}</WithEllipsis><div>.{extension}</div> 
                    {/* <FileSize>{humanFileSize(size, true)}</FileSize> */}
                </FileName>
            </Wrapper>
        )
    }
}

const Wrapper = styled.div`
    padding: 5px;
    border-radius: 4px;
    border: 1px #e8e9f2 solid;
    margin: 4px;
    margin-left: 2px;
    background-color: #97d1ea;
    font-size: 12px;
    width: 100%;
    cursor: pointer;
    position: relative;

`

const Progress = styled.div`
    position: absolute;
    height: 100%;
    ${props => props.uploadProgress && css`width: ${props.uploadProgress}%;`};
    background-color: gray;
    opacity: 0.6;
    top: 0px;
    left: 0px;
`

const FileSize = styled.div`
    font-size: 12px;
    margin-left: 5px;
`

const FileName = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: left;
    position: relative;
`

const WithEllipsis = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 120px;
`